/* eslint-disable global-require */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { cmsContent } from '../api/cmsContent/cmsContent'

i18n
  .use(initReactI18next as any) // passes i18n down to react-i18next
  .init({
    resources: {},
    lng: 'de',
    keySeparator: '.', // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

type BrandName = string

const staticNamespaces = [
  'form',
  'data',
  'summary',
  'confirmation',
  'validation',
  'header',
  'error',
  'linkexpired',
  'purchased',
  'offerexpired',
  'documentsupload',
  'leadpage',
  'chi',
  'common',
] as const
const cmsNamespaces = [
  'links',
  'footer',
  'leadpage',
  'contact',
  'summary',
] as const

type StaticNamespace = typeof staticNamespaces[number]
type CmsNamespace = typeof cmsNamespaces[number]

export default async function loadResources(brandName: BrandName) {
  const staticTranslationsPromise = Promise.all(
    staticNamespaces.map(async (item: StaticNamespace) => {
      const module = await import(
        `../../resources/${brandName}/content/${item}.json`
      )
      i18n.addResourceBundle('de', item, module.default, true, true)
    })
  )

  const cmsTranslationsPromise = cmsContent()
    .then(cmsData => {
      cmsNamespaces.forEach((namespace: CmsNamespace) => {
        if (cmsData[namespace]) {
          i18n.addResourceBundle(
            'de',
            namespace,
            cmsData[namespace],
            true,
            true
          )
        }
      })
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.error('Failed to load CMS translations:', error)
    })

  await Promise.all([staticTranslationsPromise, cmsTranslationsPromise])
}
